<template>
  <v-col
    :lg=cols_number
    :md=cols_number
    :xl=cols_number
    sm="4"
  >
    <v-img
      :src="require('@/assets/medallas/' + value.image)"
      height="150"
      contain
    />
  </v-col>
</template>

<script>
  export default {
    name: 'medalla',
    props: {
      value: {
        type: Object,
        default: () => ({}),
      },
      cols_number: {
        type: Number,
        default: () => 4,
      },
    },
  }
</script>

<style scoped>

</style>
